import FilterRefinementList from './FilterRefinementList';
import Close from '@monofront/design-system/visuals/Icons/Old/Close';
import Button from '@monofront/design-system/components/Button';
import { Stats } from 'react-instantsearch';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { LayoutContext } from '@context/LayoutContext';

interface IFilterBarProps {
  isSidebarOpen: boolean;
  handleToggleSidebar: () => void;
  collectionLevel?: number;
}

const FilterBar: React.FC<IFilterBarProps> = ({
  isSidebarOpen,
  handleToggleSidebar,
  collectionLevel,
}) => {
  const tCatalog = useTranslations('Catalog');
  const { mainHeaderHeight } = useContext(LayoutContext);

  return (
    <>
      <div
        className={`mobile-only container ${isSidebarOpen ? `is-open` : ``}`}
      >
        <div className="header">
          <span />
          <span className="title">{tCatalog('filterProducts')}</span>
          <div className="close-button" onClick={handleToggleSidebar}>
            <Close width={12} height={12} />
          </div>
        </div>
        <div className="content">
          <FilterRefinementList collectionLevel={collectionLevel} />
          <div className="footer">
            <div className="footer-button">
              <Button
                onClick={handleToggleSidebar}
                dataTestId="FilterBar-Button-see-results"
              >
                <Stats
                  translations={{
                    rootElementText({ nbHits }) {
                      return tCatalog('seeResults', { nbHits });
                    },
                  }}
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
      <style jsx global>
        {`
          @media (max-width: 800px) {
            body {
              height: ${!isSidebarOpen ? `auto` : `100vh`};
              overflow: ${!isSidebarOpen ? `auto` : `hidden`};
            }
          }
        `}
      </style>
      <style jsx>{`
        .container {
          flex: 1;
          min-width: 250px;
          position: sticky;
          height: 100%;
        }

        .header {
          display: none;
        }

        .footer {
          display: none;
        }

        @media (max-width: 1011px) {
          .container {
            top: ${mainHeaderHeight}px;
          }
        }

        @media (max-width: 800px) {
          .container {
            background: var(--white);
            position: fixed;
            top: 0;
            right: 0;
            backface-visibility: hidden;
            transform: translate3d(100%, 0, 0);
            transition: transform 0.5s ease;
            height: 100%;
            max-height: 100%;
            z-index: var(--zindex-fixed);
            width: 100%;
            overflow-y: auto;
          }

          .is-open {
            transition: all 0.5s ease;
            transform: translate3d(0, 0, 0);
          }

          .header {
            display: flex;
            padding: var(--space-3);
            border-bottom: var(--border);
            justify-content: space-between;
            align-items: center;
          }

          .title {
            font-size: var(--font-size-3);
          }

          .footer {
            display: block;
            position: sticky;
            bottom: 0;
            z-index: var(--zindex-sticky);
            width: 100%;
            background-color: var(--white);
            padding: var(--space-3) var(--space-6);
            border-top: var(--border);
          }

          .footer-button {
            width: 100%;
          }

          .close-button {
            padding-right: var(--space-3);
          }
        }
      `}</style>
    </>
  );
};

export default FilterBar;
